import { Portal } from '@radix-ui/react-portal';
import React, { FC } from 'react';

import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from '../../../../../builder-io/storyblocks-design-system/components/atoms/Collapsible';
import TabbedRelatedVideo from '../../../../../common/components/TabbedRelatedVideo';
import { ContentType } from '../../../../Shared/enums';
import { FollowableArrow } from './FollowableArrow';

interface SameShootSameModelSimilarClipsDrawerProps {
  stockItemId: number;
  contentType: ContentType;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: React.ReactNode;
  portalContainer: HTMLElement | null;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  elementToPointTo: HTMLElement | null;
}

const SameShootSameModelSimilarClipsDrawer: FC<
  SameShootSameModelSimilarClipsDrawerProps
> = ({
  stockItemId,
  contentType,
  open,
  onOpenChange,
  trigger,
  portalContainer,
  onMouseEnter,
  onMouseLeave,
  elementToPointTo,
}) => {
  const onClose = () => {
    onOpenChange(false);
  };

  const content = (
    <CollapsibleContent asChild>
      <div
        data-testid="same-shoot-same-model-similar-clips-drawer"
        className="searchDrawer w-full bg-transparent my-2.5 py-0 col-span-1 md:col-span-2 lg:col-span-3 3xl:col-span-4 4xl:col-span-5 relative"
        onMouseEnter={() => {
          onMouseEnter?.();
        }}
        onMouseLeave={() => {
          onMouseLeave?.();
        }}
      >
        {/* NOTE: trigger is not used here b/c the trigger is only displayed while the VideoCard is hovered */}
        <FollowableArrow
          trigger={elementToPointTo}
          container={portalContainer}
        />

        <div className="bg-gray-110 rounded-lg p-6">
          <TabbedRelatedVideo
            stockItemId={stockItemId}
            contentType={contentType}
            pageSize={8}
            onClose={onClose}
          />
        </div>
      </div>
    </CollapsibleContent>
  );

  const portaledContent = (
    <Portal container={portalContainer}>{content}</Portal>
  );

  return (
    <CollapsibleRoot open={open} onOpenChange={onOpenChange}>
      <CollapsibleTrigger asChild>{trigger}</CollapsibleTrigger>
      {portalContainer ? portaledContent : content}
    </CollapsibleRoot>
  );
};

export default SameShootSameModelSimilarClipsDrawer;
